<template>
  <div class="search-sidebar">
    <h1 class="search-sidebar__header">{{ tHeader }}</h1>

    <div class="input-group custom" style="margin-bottom: 10px">
      <input type="text"
             v-model="str"
             :placeholder="tSearchPlaceholder">
      <span class="input-icon">
               <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                    :style="{verticalAlign: 'baseline'}"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 250.313 250.313" style="enable-background:new 0 0 250.313 250.313;"
                    xml:space="preserve">
                    <g id="Search">
                        <path :fill="shopColor"
                              style="fill-rule:evenodd;clip-rule:evenodd;"
                              d="M244.186,214.604l-54.379-54.378c-0.289-0.289-0.628-0.491-0.93-0.76
                            c10.7-16.231,16.945-35.66,16.945-56.554C205.822,46.075,159.747,0,102.911,0S0,46.075,0,102.911
                            c0,56.835,46.074,102.911,102.91,102.911c20.895,0,40.323-6.245,56.554-16.945c0.269,0.301,0.47,0.64,0.759,0.929l54.38,54.38
                            c8.169,8.168,21.413,8.168,29.583,0C252.354,236.017,252.354,222.773,244.186,214.604z M102.911,170.146
                            c-37.134,0-67.236-30.102-67.236-67.235c0-37.134,30.103-67.236,67.236-67.236c37.132,0,67.235,30.103,67.235,67.236
                            C170.146,140.044,140.043,170.146,102.911,170.146z"/>
                    </g>
                </svg>
            </span>
    </div>

    <div class="categories-tree__container">
      <div class="categories-tree__mobile-toggle" @click="e => e.target.classList.toggle('active')">
        <p>{{ tFilter }}</p>
        <div><img src="../../static/assets/img/black-arrow-down.svg" alt=""></div>
      </div>

      <div class="shop-filters__container">
        <h1>{{ tFilter }}</h1>
        <div class="shop-filters">
          <div class="slider-container">
            <div class="slider-controller" @click="e => e.target.classList.toggle('slide-out')">
              <p>{{ tFilterAlphabetical }}</p>
              <div><img src="../../static/assets/img/black-arrow-down.svg" alt=""></div>
            </div>
            <div class="alphabetic-filter-grid">
              <div
                v-for="(filter, index) in alphabeticalFilters"
                :key="`filter-${index}`"
                @click="setAlphabeticalFilter(filter.value)"
                :class="{active: filter.value === getAlphabeticalFilter}"
              >
                <p>{{ filter.name }}</p>
              </div>

            </div>
          </div>
          <div v-for="category in categories" v-if="category.children" :key="category.id" class="slider-container">
            <div class="slider-controller" @click="e => e.target.classList.toggle('slide-out')">
              <p>{{ category.name }}</p>
              <div><img src="../../static/assets/img/black-arrow-down.svg" alt=""></div>
            </div>
            <div>
              <categories v-for="node in category.children" :item="node" :nodes="node.children" :depth="0"></categories>
            </div>
          </div>
        </div>
        <button class="btn-outline" @click="clearFilters"><span>{{ tFilterClean }}</span></button>
      </div>
    </div>


    <!--        <div class="input-group -select mb-4">-->
    <!--            <select class="custom-select"-->
    <!--                    v-model="orderBy">-->
    <!--                <option disabled :value="null">{{tOrderBy}}</option>-->
    <!--                <option :value="key"-->
    <!--                        :key="'orderByOption'+key"-->
    <!--                        v-for="(val, key) in orderByValues">{{val}}-->
    <!--                </option>-->

    <!--            </select>-->
    <!--            &lt;!&ndash;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;new-icon-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
    <!--            <span class="icon-svg">-->
    <!--               <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"-->
    <!--                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"-->
    <!--                    width="12px" height="8px" viewBox="0 0 255 255"-->
    <!--                    xml:space="preserve">-->
    <!--                    <g id="arrow-drop-down" fill="#EC6723">-->
    <!--                        <polygon points="0,63.75 127.5,191.25 255,63.75"/>-->
    <!--                    </g>-->
    <!--                </svg>-->
    <!--            </span>-->
    <!--            &lt;!&ndash;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;end-new-icon-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
    <!--        </div>-->

    <!--        <div class="row d-lg-none mb-4">-->
    <!--            <div class="col-12 col-md-6">-->
    <!--                <a class="btn-orange"-->
    <!--                   data-toggle="collapse"-->
    <!--                   href="#collapseShopsSidebar"-->
    <!--                   role="button"-->
    <!--                   aria-expanded="false"-->
    <!--                   aria-controls="_first-menu">-->
    <!--                    {{tShowCategories}}-->
    <!--                </a>-->
    <!--            </div>-->
    <!--            <div class="col-12 col-md-6">-->
    <!--                <a :href="backBtnLink"-->
    <!--                   class="btn-orange">{{backBtnTitle}}</a>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--        <div class="collapse multi-collapse d-lg-block" id="collapseShopsSidebar">-->

    <!--            <h4 class="mb-3">{{tCategoriesTitle}}</h4>-->

    <!--            <div class="form-check custom"-->
    <!--                 :key="category.id"-->
    <!--                 v-for="category in categories">-->
    <!--                <input type="checkbox"-->
    <!--                       :id="'categoryCheckbox'+category.id"-->
    <!--                       class="form-check-input"-->
    <!--                       v-model="selectedCategories"-->
    <!--                       :value="category.id">-->
    <!--                <label class="form-check-label cursor-pointer"-->
    <!--                       :for="'categoryCheckbox'+category.id">{{category.name}}</label>-->
    <!--            </div>-->
    <!--        </div>-->
  </div>
</template>

<script>
import * as AppConfig from '@/config/AppConfig'
import {mapActions, mapGetters} from 'vuex'

import Categories from "./Categories";
import {T_FILTER_ALPHABETICAL, T_FILTER_CLEAN, T_HEADER} from "../config/AppConfig";

export default {
  name: 'SearchSidebar',
  components: {Categories},
  data() {
    return {
      shopColor: AppConfig.SHOP_COLOR,
      tSearchPlaceholder: AppConfig.T_SEARCH_PLACEHOLDER,
      tShowCategories: AppConfig.T_SHOW_CATEGORIES,
      backBtnTitle: AppConfig.T_BACK_BTN,
      backBtnLink: AppConfig.BACK_BTN_LINK,
      tOrderBy: AppConfig.T_ORDER_BY,
      tCategoriesTitle: AppConfig.T_CATEGORIES,
      orderByValues: AppConfig.ORDER_BY_VALUES,
      orderBy: null,
      str: '',
      selectedCategories: [],
      alphabeticalFilters: [
        {name: 'A-Z', value: null},
        {name: 'AB', value: 'ab'},
        {name: 'CD', value: 'cd'},
        {name: 'EF', value: 'ef'},
        {name: 'GH', value: 'gh'},
        {name: 'IJ', value: 'ij'},
        {name: 'KL', value: 'kl'},
        {name: 'MN', value: 'mn'},
        {name: 'OP', value: 'op'},
        {name: 'QR', value: 'qr'},
        {name: 'ST', value: 'st'},
        {name: 'UV', value: 'uv'},
        {name: 'WX', value: 'wx'},
        {name: 'YZ', value: 'yz'},
        {name: '0-9', value: '123456789'}
      ],
      tHeader: AppConfig.T_HEADER,
      tFilter: AppConfig.T_FILTER,
      tFilterAlphabetical: AppConfig.T_FILTER_ALPHABETICAL,
      tFilterClean: AppConfig.T_FILTER_CLEAN
    }
  },
  computed: {
    ...mapGetters(['getAlphabeticalFilter']),
    categories() {
      return this.$store.getters.getStoreVar('categories')
    }
  },
  methods: {
    ...mapActions(['getCategories', 'setStoreVar']),
    setAlphabeticalFilter(filter) {
      this.$store.dispatch('setFilter', {key: 'alphabetical', value: filter})
    },
    clearFilters() {
      this.$store.dispatch('clearFilters')
    }
  },
  watch: {
    selectedCategories() {
      this.setStoreVar({key: 'selectedCategories', data: this.selectedCategories})
    },
    orderBy() {
      this.setStoreVar({key: 'orderBy', data: this.orderBy})
    },
    str() {
      this.setStoreVar({key: 'str', data: this.str})
    }
  },
  created() {
    this.getCategories()
  }
}
</script>

<style>
.input-group.custom input:focus {
  outline: none;
  box-shadow: none;
  border: 1px solid var(--shop-color);
}

.alphabetic-filter-grid > div:hover,
.alphabetic-filter-grid > div.active {
  background-color: var(--shop-color);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchSidebar.vue